import * as React from "react";
import * as styles from "./MobileGlobalSearchSummary.module.scss";
import { Button } from "react-bootstrap";

export const Location: React.FC<any> = (props) => {
  return <div className={styles.location}>{props.children}</div>;
};

export const Container: React.FC<any> = (props) => {
  return (
    <div className={styles.container} {...props}>
      {props.children}
    </div>
  );
};

export const MobileInputWrapper: React.FC<any> = (props) => {
  return <div className={styles.mobileInputWrapper}>{props.children}</div>;
};

export const MobileFindButton: React.FC<any> = (props) => {
  return <Button className={styles.primaryButton}>{props.children}</Button>;
};
